module.exports = __webpack_public_path__ + "assets/img/chirp-notifications-active.c2f9b700.svg";